import { ResetMethodTab } from "@/modules/auth/common/enum";
import type { ITabItemsProps } from "@/shared/common/types";
import { AccountIcon, CardIcon } from "@/shared/components/SvgIcons";
import type { TTabItem } from "@ab.uitools/ui-library/components/Tab/types";

export const getResetMethodTabItems = ({ t }: ITabItemsProps): TTabItem[] => [{
  value: ResetMethodTab.Account,
  label: t("auth.accountOrCardVerification.accountNumber"),
  dataId: "reset-tab-1",
  disabled: false,
  iconProps: {
    Component: AccountIcon,
  },
},
  {
    value: ResetMethodTab.Card,
    label: t("auth.accountOrCardVerification.cardNumber"),
    dataId: "reset-tab-2",
    disabled: false,
    iconProps: {
      Component: CardIcon,
    },
  }];

